export default __webpack_public_path__ + "d20709b9567b42383ae19a19d71e5437.png";